import { render } from "./SkeletonLoader.vue?vue&type=template&id=6ad92396&scoped=true"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js"

import "./SkeletonLoader.vue?vue&type=style&index=0&id=6ad92396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad92396"]])

export default __exports__